// extracted by css-extract-rspack-plugin
export default {"menuItem":"mv5Bj","dangerItem":"A3B5E"};